import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// `withCredentials` garante que o cookie httpOnly `access_token` seja enviado
// automaticamente em cada requisição. Não armazenamos o token em
// localStorage — ele é httpOnly no servidor e inacessível ao JavaScript,
// fechando a superfície de ataque XSS comum em painéis admin.
const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

export default api;
